const handleVibration = (repeatCount) => {
    if (window.Telegram && window.Telegram.WebApp.HapticFeedback) {
        for (let i = 0; i < repeatCount; i++) {
            window.Telegram.WebApp.HapticFeedback.impactOccurred('heavy');
        }
    } else {
        console.log('텔레그램 환경에서 햅틱 효과를 사용할 수 없습니다.');
    }
};

const changeNum = (n) => {
    let num = String(n)
    let arr = num.split('.')
    let result;

    if (arr[1]) {
        result = Number(arr[0]).toLocaleString() + "." + arr[1]
    }
    else {
        result = Number(arr[0]).toLocaleString()
    }

    return result;
}

const Decimalization = (n) => {
    let str = String(n).toUpperCase()
    let arr = str.split('E-')
    let result;
    if (arr[1]) {
        result = (Number(arr[0]) / Math.pow(10, Number(arr[1]))).toFixed(Number(arr[1]) + arr[0].length - 2)
    }
    else {
        result = arr[0]
    }

    return result
}

const RoundDown = (n, p) => {
    let num = Decimalization(n)
    let arr = num.split('.')
    let result;

    if (arr[1] && arr[1].length > p && p != 0) {
        let point = arr[1].slice(0, Number(p))
        result = arr[0] + "." + point
    }
    else if (arr[1] && arr[1].length <= p && p != 0) {
        let zero = ''
        let len = p - arr[1].length
        for (let i = 0; i < len; i++) {
            zero += '0'
        }
        result = arr[0] + "." + arr[1] + zero
    }
    else {
        result = Number(arr[0]).toFixed(p)
    }

    return changeNum(result);
}

const changeUnits = (n) => {
    let num = Number(n)
    let result;

    if (num >= 10000000000000) result = RoundDown(String(n / 1000000000000), 0) + 'T'
    else if (num >= 10000000000) result = RoundDown(String(n / 1000000000), 0) + 'B'
    else if (num >= 10000000) result = RoundDown(String(n / 1000000), 0) + 'M'
    else if (num >= 10000) result = RoundDown(String(n / 1000), 0) + 'K'
    else result = changeNum(n)

    return result;
}

// const changeUnits = (n) => {
//     let num = Number(n);
//     let result;
//     let unit = ''; // 기본값을 빈 문자열로 설정

//     if (num >= 10000000000000) {
//         result = RoundDown(String(n / 1000000000000), 0);
//         unit = 'T';
//     } else if (num >= 10000000000) {
//         result = RoundDown(String(n / 1000000000), 0);
//         unit = 'B';
//     } else if (num >= 10000000) {
//         result = RoundDown(String(n / 1000000), 0);
//         unit = 'M';
//     } else if (num >= 10000) {
//         result = RoundDown(String(n / 1000), 0);
//         unit = 'K';
//     } else {
//         result = changeNum(n);
//         unit = ''; // 단위 없음
//     }

//     return { result, unit };
// };

const changeUnitsOrigial = (n) => {
    let num = Number(n)
    let result;

    if (num >= 1000000000000) result = RoundDown(String(n / 1000000000000), 2) + 'T'
    else if (num >= 1000000000) result = RoundDown(String(n / 1000000000), 2) + 'B'
    else if (num >= 1000000) result = RoundDown(String(n / 1000000), 2) + 'M'
    else if (num >= 1000) result = RoundDown(String(n / 1000), 2) + 'K'
    else result = changeNum(n)

    return result;
};

const formatUTCDateTime = (dateInput) => {
    if (!dateInput) return '';

    // 1) UTC 기준 Date 객체 생성
    let date;
    if (typeof dateInput === 'string') {
        // "YYYY-MM-DD HH:mm:ss" 이라고 가정
        const [datePart, timePart] = dateInput.split(' ');
        if (!timePart) return '';
        const [Y, M, D] = datePart.split('-').map(Number);
        const [h, m, s] = timePart.split(':').map(Number);
        // Date.UTC → UTC 기준 밀리초, new Date(ms) → 로컬 기준 객체
        date = new Date(Date.UTC(Y, M - 1, D, h, m, s));
    } else if (typeof dateInput === 'number') {
        // 밀리초 타임스탬프라고 가정 (UTC 기준)
        date = new Date(dateInput);
    } else if (dateInput instanceof Date) {
        // Date 객체는 내부적으로 UTC ms를 들고 있으므로 그대로
        date = dateInput;
    } else {
        return '';
    }

    // 2) 로컬 시간으로 포맷
    const pad2 = n => String(n).padStart(2, '0');
    const Y = date.getFullYear();
    const M = pad2(date.getMonth() + 1);
    const D = pad2(date.getDate());
    const h = pad2(date.getHours());
    const m = pad2(date.getMinutes());
    const s = pad2(date.getSeconds());

    return `${Y}-${M}-${D} ${h}:${m}:${s}`;
}

export { handleVibration, changeNum, changeUnitsOrigial, changeUnits, formatUTCDateTime }